import React, { useEffect, useState } from 'react';
import { Form, Card, Tag, Input, Space } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllBatches
  //   createWastage,
  //   getPastContainerDetails
} from '../../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import useServerPagination from '@/hooks/useServerPagination';
import moment from 'moment';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import Layout from '@/common/Layout';
import { useLocation } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';

const { Search } = Input;

const QAListpage = () => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();
  const { SuperadminQCdata } = getRoles('Quality Control');
  const { batchdetails, pagination } = useSelector((state) => state.qaapproval);

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);

  const { page, pageSize, onChange, reset } = useServerPagination();
  const [search, setSearch] = useState('');
  const [batches, setBatches] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [allowedMaterialId, setAllowedMaterialId] = useState(null);

  console.log(batchdetails);
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllWastageDetails();
  }, [page, pageSize, search]);

  const handleGetAllWastageDetails = () => {
    const payload = { page, per_page: pageSize, status: 'Quarantine', search };
    dispatch(getAllBatches(payload)).then((response) => {
      if (response?.payload.success) {
        setBatches(response?.payload?.data);
      }
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    reset();
  };

  const columns = [
    {
      title: 'Batch Number',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return searchParams.get('type') == 'test_requests' ? (
          <a
            href={`test_request_form?id=${record?.id}`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : searchParams.get('type') == 'lc_sampling' &&
          (user?.role == 'user' || user?.role == 'qc_initiator') &&
          record?.lc_status === 'QALC Pending' ? (
          text
        ) : searchParams.get('type') == 'lc_sampling' &&
          user?.role == 'qc_initiator' ? (
          <a
            href={`qc-create-checklist/${record?.id}?type=sampling`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : searchParams.get('type') == 'lc_sampling' ? (
          <a
            href={`create-checklist/${record?.id}?type=sampling`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : user?.level == 3 || SuperadminQCdata?.[0]?.level == 3 ? (
          <a
            href={`qc-approval?id=${record?.id}`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {text}
          </a>
        ) : (
          text
        );
      }
    },
    {
      title: 'Material Code',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.code || 'NA';
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'material_name',
      key: 'material_name',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.name || 'NA';
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'received_quantity',
      key: 'received_quantity',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.received_quantity || 'NA';
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return (
          (searchParams.get('type') == 'test_requests' ||
          searchParams.get('type') == 'batches' ? (
            <Tag
              color={
                record?.status === 'Under Sampling'
                  ? '#007bff'
                  : record?.status === 'Approved'
                  ? '#28a745'
                  : record?.status === 'Expired'
                  ? '#dc3545'
                  : record?.status === 'Partially ID Approved'
                  ? '#00ffc8ff'
                  : record?.status === 'Under Test'
                  ? '#343a40'
                  : '#FF9800'
              }
            >
              {record?.status?.toUpperCase()}
            </Tag>
          ) : (
            <Tag
              color={
                record?.lc_status === 'WH LC Pending'
                  ? '#007bff'
                  : record?.lc_status === 'QALC Approved'
                  ? '#28a745'
                  : record?.lc_status === 'LC Approved'
                  ? '#28a745'
                  : record?.lc_status === 'Rejected'
                  ? '#dc3545'
                  : record?.lc_status === 'QALC Pending'
                  ? '#17a2b8'
                  : record?.lc_status === 'Under Test'
                  ? '#343a40'
                  : '#FF9800'
              }
            >
              {record?.lc_status?.toUpperCase()}
            </Tag>
          )) || 'NA'
        );
      }
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Type',
      dataIndex: 'is_code_transfer',
      key: 'is_code_transfer',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return (
          (
            <Tag ghost color={text ? 'processing' : 'default'}>
              {text ? 'Code to Code' : 'General'}
            </Tag>
          ) || 'NA'
        );
      }
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'Status Updated On',
      dataIndex: 'approved_on',
      key: 'approved_on',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.status === 'Quarantine'
          ? moment(record?.createdAt).format('DD MMM YYYY')
          : record?.qc_update_logs[0]?.updated_date
          ? moment(record?.qc_update_logs[0]?.updated_date).format(
              'DD MMM YYYY'
            )
          : 'NA';
      }
    },
    searchParams.get('type') !== 'lc_sampling' && {
      title: 'View',
      dataIndex: 'inhouse_batch_number',
      key: 'inhouse_batch_number',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return searchParams.get('type') == 'test_requests' ? (
          <a
            href={`test_request_form?id=${record?.id}&type=in_active`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            <EyeOutlined />
          </a>
        ) : user?.level == 3 ||
          user?.level == 2 ||
          SuperadminQCdata?.[0]?.level == 3 ||
          SuperadminQCdata?.[0]?.level == 3 ? (
          <a
            href={`qc-approval?id=${record?.id}&type=in_active`}
            onClick={(e) => handleLinkClick(e, record)}
          >
            {' '}
            <EyeOutlined />
          </a>
        ) : (
          <EyeOutlined />
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    }
  ].filter(Boolean);

  // Row selection logic - same as first component
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      console.log('Selection changed:', newSelectedRowKeys, selectedRows);

      // If deselecting all rows, reset everything
      if (newSelectedRowKeys.length === 0) {
        setSelectedRowKeys([]);
        setAllowedMaterialId(null);
        return;
      }

      // Get the current row's material_id from the first selected row
      const firstSelectedRow = selectedRows[0];
      if (!firstSelectedRow) {
        setSelectedRowKeys(newSelectedRowKeys);
        return;
      }

      // Set or get the allowed material_id
      const currentMaterialId =
        allowedMaterialId || firstSelectedRow.material_id;

      // If first selection, set the allowed material_id
      if (allowedMaterialId === null) {
        setAllowedMaterialId(currentMaterialId);
      }

      // Filter selected keys to only include rows with matching material_id
      const filteredKeys = [];
      selectedRows.forEach((row) => {
        if (row.material_id === currentMaterialId) {
          const key = row.id;
          if (key) {
            filteredKeys.push(key);
          }
        }
      });

      console.log('Filtered keys:', filteredKeys);
      setSelectedRowKeys(filteredKeys);
    },

    // getCheckboxProps: (record) => {
    //   // Disable based on specific status conditions (adjust as needed)
    //   if (record.status === 'QA Pending' || record.status === 'Approved') {
    //     return {
    //       disabled: true,
    //       name: record.name
    //     };
    //   }

    //   // If there's an allowed material_id and this row has a different material_id
    //   if (
    //     allowedMaterialId !== null &&
    //     record.material_id !== allowedMaterialId
    //   ) {
    //     return {
    //       disabled: true,
    //       name: record.name
    //     };
    //   }

    //   return {
    //     disabled: false,
    //     name: record.name
    //   };
    // }
    getCheckboxProps: (record) => {
      // Only enable checkboxes for WH LC Pending status
      if (user?.role === 'qc_initiator') {
        if (record.lc_status !== 'QALC Pending') {
          return {
            disabled: true,
            name: record.name
          };
        }
      } else if (record.lc_status !== 'WH LC Pending') {
        return {
          disabled: true,
          name: record.name
        };
      }

      // If there's an allowed material_id and this row has a different material_id
      if (
        allowedMaterialId !== null &&
        record.material_id !== allowedMaterialId
      ) {
        return {
          disabled: true,
          name: record.name
        };
      }

      return {
        disabled: false,
        name: record.name
      };
    }
  };

  const saveBatchesToLocalStorage = (batchIds) => {
    // If role is qc_initiator, save line_clearance_batches id instead of batch ids
    if (user?.role === 'qc_initiator') {
      // Find the selected batches from the batches array
      const selectedBatches = batches.filter((batch) =>
        batchIds.includes(batch.id)
      );

      // Extract line_clearance_batches ids from selected batches
      const lineClearanceIds = selectedBatches
        .map((batch) => batch.line_clearance_batches?.[0]?.id)
        .filter((id) => id !== undefined && id !== null);

      // Save line_clearance_batches ids to localStorage
      localStorage.removeItem('batches');
      if (lineClearanceIds.length > 0) {
        localStorage.setItem('batches', JSON.stringify(lineClearanceIds));
      }
    } else {
      // For other roles, save batch ids as before
      localStorage.removeItem('batches');
      // If batchIds is an array, convert to comma-separated string
      const batchIdsString = Array.isArray(batchIds)
        ? batchIds.join(',')
        : batchIds;
      localStorage.setItem('batches', batchIdsString);
    }
  };

  const handleCampaign = (batchIds) => {
    saveBatchesToLocalStorage(batchIds);

    // Navigate based on role
    if (user?.role === 'qc_initiator') {
      history.push(`/qc-create-checklist/${batchIds[0]}?type=sampling`, {});
    } else {
      history.push(`/create-checklist/${batchIds[0]}?type=sampling`, {});
    }
  };

  const handleLinkClick = (e, record) => {
    // Save the single batch to localStorage
    saveBatchesToLocalStorage([record.id]);
  };

  console.log(allowedMaterialId, selectedRowKeys, 'allowedMaterialId');

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical">
        <Card
          title={
            <span>
              {searchParams.get('type') == 'test_requests'
                ? 'Test Request Forms'
                : 'Batches List'}
            </span>
          }
          className={`${styles.cardStyles_approver}`}
          extra={
            <Space>
              <Search
                onChange={(e) => handleChange(e)}
                className={`w-100 ${styles.searchbar}`}
                justify="start"
                align="start"
                placeholder="Search by Batch number"
              />
            </Space>
          }
        >
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              rowSelection={
                searchParams.get('type') !== 'test_requests' &&
                searchParams.get('type') !== 'batches'
                  ? rowSelection
                  : ''
              }
              rowKey="id"
              showPaginationMeta
              pagination={{
                size: 'small',
                total: pagination?.total_records || 0,
                current: page,
                pageSize,
                onChange
              }}
              dataSource={batches}
            />
          </div>
        </Card>
        <br />
        <FormItem className="text-center">
          <Space>
            <CustomButton
              htmlType="button"
              type="primary"
              onClick={() => handleCampaign(selectedRowKeys)}
              disabled={selectedRowKeys?.length ? false : true}
            >
              Initiate Line Clearance
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </Layout>
  );
};
export default QAListpage;
